const initialStateLEQuestionsState = {
  previousScreen: 'NO_SCREEN_TO_SHOW',
  currentScreen: 'LEQ_WELCOME_SCREEN',
  limitEnhanceDetails: {},
  ackScreenDetails: {},
  limit_enhanceAPICall: {
    response: {},
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  save_le_detailsAPICall: {
    response: {},
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
  auto_limit_enhanceAPICall: {
    response: {},
    isLoading: false,
    isSuccess: false,
    isError: false,
  },
};

export default initialStateLEQuestionsState;
